import {
  Box,
  Button,
  Drawer,
  Grid2,
  IconButton,
  Link,
  MenuItem,
  Typography,
} from "@mui/material";
import React from "react";
import RenderLogo from "./RenderLogo";
import PrimaryIcon from "./PrimaryIcon";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import ReferralImage from "Assets/Images/Referral.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ReactComponent as HomeIcon } from "Assets/Icons/Drawer/Home.svg";
import { ReactComponent as JoinReferral } from "Assets/Icons/Drawer/JoinReferral.svg";
import { ReactComponent as CurriculumClasses } from "Assets/Icons/Drawer/CurriculumClasses.svg";
import { ReactComponent as CareerClasses } from "Assets/Icons/Drawer/CareerClasses.svg";
import { ReactComponent as CommunityClasses } from "Assets/Icons/Drawer/CommunityClasses.svg";
import { ReactComponent as Classroom } from "Assets/Icons/Drawer/Classroom.svg";
import { ReactComponent as Contest } from "Assets/Icons/Drawer/Contest.svg";
import { ReactComponent as ProblemsTests } from "Assets/Icons/Drawer/ProblemsTests.svg";
import { ReactComponent as BusinessCase } from "Assets/Icons/Drawer/BusinessCase.svg";
import { ReactComponent as TeachingAssistant } from "Assets/Icons/Drawer/TeachingAssistant.svg";
import { ReactComponent as LeaderBoard } from "Assets/Icons/Drawer/LeaderBoard.svg";
import { ReactComponent as CareerHub } from "Assets/Icons/Drawer/CareerHub.svg";
import { ReactComponent as JobInsights } from "Assets/Icons/Drawer/JobInsights.svg";
import { ReactComponent as MockInterviews } from "Assets/Icons/Drawer/MockInterviews.svg";
import { ReactComponent as PlacementPolicy } from "Assets/Icons/Drawer/PlacementPolicy.svg";
import { ReactComponent as Whatsapp } from "Assets/Icons/Drawer/Whatsapp.svg";
import { ReactComponent as DiscussionHub } from "Assets/Icons/Drawer/DiscussionHub.svg";
import { ReactComponent as CoursePause } from "Assets/Icons/Drawer/CoursePause.svg";
import { ReactComponent as CourseReset } from "Assets/Icons/Drawer/CourseReset.svg";
import { ReactComponent as ChangeSchedule } from "Assets/Icons/Drawer/ChangeSchedule.svg";
import { ReactComponent as LectureRecording } from "Assets/Icons/Drawer/LectureRecording.svg";
import { ReactComponent as PersonalDetails } from "Assets/Icons/Drawer/PersonalDetails.svg";
import { ReactComponent as StudentPolicy } from "Assets/Icons/Drawer/StudentPolicy.svg";
import { ReactComponent as DsmlHandbook } from "Assets/Icons/Drawer/DsmlHandbook.svg";
import { useNavigate } from "react-router-dom";

const styles = (theme) => ({
  padding: "20px",
  minWidth: "340px",
  overflow: "auto",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  "& .menuItem": {
    padding: "10px 16px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    "&>div": {
      fontSize: "16px",
      fontWeight: 500,
    },
  },
  "& .active": {
    background: theme.palette.background.default,
    color: theme.palette.primary.main,
    "& svg": {
      fill: theme.palette.primary.main,
    },
  },
  "& .referralBox": {
    padding: "16px",
    background: "#FFF7E8",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  "& .primaryText": {
    color: theme.palette.primary.main,
  },
  "& .tourBox": {
    padding: "16px",
    background: "#FFF7E8",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "8px",
  },
});

const SideDrawer = ({ open, handleClose = () => {} }) => {
  const navigate = useNavigate();

  let menuList = [
    {
      label: "Home",
      icon: HomeIcon,
      url: "/",
      type: "link",
    },
    {
      label: "Join Referral Program",
      icon: JoinReferral,
      url: "/invite-friends",
      type: "link",
    },
    {
      type: "referral",
    },
    {
      label: "Learn and Simulate",
      type: "heading",
    },
    {
      label: "Curriculum and Classes",
      icon: CurriculumClasses,
      url: "/core-curriculum/0/classes",
      type: "link",
    },
    {
      label: "Career and Classes",
      icon: CareerClasses,
      url: "",
      type: "link",
    },
    {
      label: "Community Classes",
      icon: CommunityClasses,
      url: "",
      type: "link",
    },
    {
      label: "Classroom",
      icon: Classroom,
      url: "/class/1",
      type: "link",
    },
    {
      label: "Contest",
      icon: Contest,
      url: "/test/1",
      type: "link",
    },
    {
      label: "All problems and Test",
      icon: ProblemsTests,
      url: "",
      type: "link",
    },
    {
      label: "Business Cases",
      icon: BusinessCase,
      url: "",
      type: "link",
    },
    {
      label: "Teaching Assistant",
      icon: TeachingAssistant,
      url: "",
      type: "link",
    },
    {
      label: "Leader Board",
      icon: LeaderBoard,
      url: "/global-leaderboard/rank",
      type: "link",
    },
    {
      label: "Career & PLACEMENTS",
      type: "heading",
    },
    {
      label: "Careers Hub",
      icon: CareerHub,
      url: "",
      type: "link",
    },
    {
      label: "Job Insights",
      icon: JobInsights,
      url: "",
      type: "link",
    },
    {
      label: "Mock Interviews",
      icon: MockInterviews,
      url: "",
      type: "link",
      desc: "Schedule today to unlock job opportunities",
    },
    {
      label: "Placement Policy",
      icon: PlacementPolicy,
      url: "",
      type: "link",
    },
    {
      label: "Social Community",
      type: "heading",
    },
    {
      label: "WhatsApp",
      icon: Whatsapp,
      url: "",
      type: "link",
    },
    {
      label: "Discussion Hub",
      icon: DiscussionHub,
      url: "/discussion-hub",
      type: "link",
    },
    {
      label: "Action Centre",
      type: "heading",
    },
    {
      label: "Course Pause",
      icon: CoursePause,
      url: "",
      type: "link",
    },
    {
      label: "Course Reset",
      icon: CourseReset,
      url: "",
      type: "link",
    },
    {
      label: "Change Batch Schedule",
      icon: ChangeSchedule,
      url: "",
      type: "link",
    },
    {
      label: "Lecture Recording Library",
      icon: LectureRecording,
      url: "",
      type: "link",
    },
    {
      label: "More",
      type: "heading",
    },
    {
      label: "Personal Details",
      icon: PersonalDetails,
      url: "",
      type: "link",
    },
    {
      label: "Student Policy",
      icon: StudentPolicy,
      url: "",
      type: "link",
    },
    {
      label: "DSML Handbook",
      icon: DsmlHandbook,
      url: "",
      type: "link",
    },
    {
      type: "tour",
    },
  ];

  const handleRedirect = (url) => {
    navigate(url);
    handleClose();
  };

  return (
    <Drawer anchor="right" open={open} onClose={handleClose}>
      <Grid2 sx={styles}>
        <Box
          display={"flex"}
          alignItems={"start"}
          justifyContent={"space-between"}
          mb="30px"
        >
          <RenderLogo />
          <IconButton onClick={() => handleClose()}>
            {" "}
            <PrimaryIcon height="15px" width="15px" icon={CloseIcon} />{" "}
          </IconButton>
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap="8px">
          {menuList?.map((menu, i) => {
            return menu?.type == "referral" ? (
              <Box className="referralBox" key={i}>
                <img src={ReferralImage} alt="f" />
                <Typography
                  lineHeight={"1.5"}
                  variant="subtitle"
                  fontWeight={500}
                >
                  Refer your friends & <br /> Earn up to{" "}
                  <span className="primaryText"> ₹12,000 </span> on every
                  enrolment!
                </Typography>
                <Button
                  onClick={() => {
                    navigate("/invite-friends");
                    handleClose();
                  }}
                  sx={{ width: "fit-content" }}
                  variant="contained"
                >
                  Start Referring Now
                </Button>
              </Box>
            ) : menu?.type == "heading" ? (
              <Typography textTransform={"uppercase"} color="secondary.light" key={i}>
                {menu?.label}
              </Typography>
            ) : menu?.type == "tour" ? (
              <Box className="tourBox" key={i}>
                <Typography variant="subtitle" fontWeight={500}>
                  What's new ! 🎉
                </Typography>
                <Link
                  fontWeight={500}
                  href="#"
                  color="primary"
                  underline="none"
                  display={"flex"}
                  alignItems={"center"}
                  gap="5px"
                >
                  Start Tour
                  <ArrowForwardIosIcon fontSize="small" />
                </Link>
              </Box>
            ) : (
              <MenuItem
                className={`menuItem ${menu.url == "/home" ? "active" : ""}`}
                onClick={() => handleRedirect(menu?.url)}
                key={i}
              >
                <PrimaryIcon icon={menu?.icon} height="18px" width="18px" />{" "}
                <Box>
                  {menu?.label}
                  {menu?.desc && (
                    <Typography variant="body2" color="secondary.light">
                      {menu?.desc}
                    </Typography>
                  )}
                </Box>
              </MenuItem>
            );
          })}
        </Box>
      </Grid2>
    </Drawer>
  );
};

export default SideDrawer;
